// extracted by mini-css-extract-plugin
module.exports = {"richtext":"RichText_richtext__4rvlm"};